import React from 'react';

import { Block } from '../common/Block.jsx';
import Utilities from '../common/Utilities.jsx';

function Checkbox(props) {
    const [id, setId] = React.useState(undefined);
    React.useEffect(() => setId(Utilities.generateUniqueId()), []);

    const formFieldProps = {};
    if (props.onInputProps) {
        props.onInputProps({ config: props.blockConfig, type: props.blockType }, formFieldProps);
    } else if (props.onFormFieldProps) {
        props.onFormFieldProps({ config: props.blockConfig, type: props.blockType }, formFieldProps);
    }
    const handleClick = (event) => {
        if (!event || !event.currentTarget) {
            return;
        }
        event.preventDefault();
        event.stopPropagation();

        if (formFieldProps.onChange) {
            formFieldProps.onChange(formFieldProps.name, formFieldProps.value ? false : true);
        }
    }
    const style = {};
    if (formFieldProps.disabled) {
        style.pointerEvents = 'none';
    }
    let design, styleLabel;
    if (props.blockConfig && props.blockConfig.layout) {
        Block.mapStyleConfigProps(style, props.blockConfig.layout, (propName, propValue, propUnit) => {
            switch (propName) {
                case 'design':
                    if (id && !Utilities.isHTMLContentEmpty(propValue)) {
                        design = propValue;
                    }
                    return true;
                case 'labelSpacing':
                    if (propValue && propUnit) {
                        styleLabel = { marginLeft: `${propValue}${propUnit}` };
                    }
                    return true;
            }
        });
    }
    return (
        <div className="cont--checkbox" style={style} onClick={handleClick}>
            <span className="checkbox__input">
                {
                    formFieldProps.value == true &&
                    <input defaultChecked={true} type="checkbox" />
                }
                {
                    !formFieldProps.value &&
                    <input type="checkbox" />
                }
            </span>
            {
                design != undefined &&
                <div className="checkbox__label richText" dangerouslySetInnerHTML={{ __html: design }} style={styleLabel} />
            }
        </div>
    );
}
export default { Component: Checkbox };